import {
  Component,
  Input,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';

import { PanelsDirective } from './panels.directive';
import { PanelsInterfaceComponent, PanelType } from './panels-interface.component';
import PropertyPanels from './common/property-panels';
import { AuthService } from 'app/core';
import { Permission } from 'app/core/enums';
import { getAllowedFields } from 'app/shared/functions';
import { RelatedToType } from 'app/shared/enums';
import { Account } from 'app/core/models/account.types';
import { PanelDef } from 'app/shared/components/panels/panels.types';
import { Property } from 'app/modules/projects/projects.types';

@Component({
  selector: 'property-panel',
  template: '<ng-template panel-host><ng-template></ng-template></ng-template>',
})
export class PanelsComponent implements OnInit, OnChanges {
  @Input() panelDef: PanelDef<any>;
  @Input() property: Property;
  @Input() account: Account;
  @Input() data: any;
  @Input() canEditPanelDef: boolean = true;
  @Input() readonly = false;
  @Output() onUpdate: EventEmitter<string> = new EventEmitter();
  @Output() onEditPanelDef: EventEmitter<any> = new EventEmitter();

  @ViewChild(PanelsDirective, { static: true }) panelHost: PanelsDirective;

  instance: any;

  private readonly authService = inject(AuthService);

  private get canEditLayout(): boolean {
    return this.authService.hasPermission(Permission.PROPERTY_DASHBOARD_EDIT_LAYOUT);
  }

  ngOnInit(): void {
    this.loadComponent();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.property && changes.property.previousValue && changes.property.currentValue) {
      if (changes.property.previousValue.id !== changes.property.currentValue.id) {
        this.loadComponent();
      }
    }
  }

  loadComponent(): void {
    if (this.panelDef.type in PropertyPanels) {
      const viewContainerRef = this.panelHost.viewContainerRef;
      viewContainerRef.clear();

      const componentRef = viewContainerRef.createComponent(PropertyPanels[this.panelDef.type]);
      const componentInstance = <PanelsInterfaceComponent>componentRef.instance;
      componentInstance.property = this.property;
      componentInstance.account = this.account;
      componentInstance.panelDef = this.panelDef;
      componentInstance.onUpdate = this.onUpdate;
      componentInstance.onEditPanelDef = this.onEditPanelDef;
      componentInstance.data = this.data;
      componentInstance.canEditPanelDef = !this.canEditLayout ? false : this.canEditPanelDef;
      componentInstance.fieldDefs = getAllowedFields(
        this.data.fieldDefs,
        RelatedToType.Property,
        false,
        false,
        this.panelDef.type === 'matrix',
      );
      componentInstance.model = this.property;
      componentInstance.readonly = this.readonly;
      componentInstance.panelDefUpdated = this.onEditPanelDef;
      componentInstance.dataUpdated = this.onUpdate;
      componentInstance.relatedToType = RelatedToType.Property;

      if (this.panelDef.type === 'table') {
        componentInstance.customObjectsOnly = true;
      }

      this.instance = componentInstance;
    }
  }
}
